import { ReactComponent as Polkadot } from "../../../components/icons/polkadot.svg";
import { useIsDark } from "../../hooks/index";
import { governanceModules, treasuryModules } from "./modules";


const polkadot = {
  name: "Polkadot",
  icon: <Polkadot />,
  identity: "polkadot",
  sub: "polkadot",
  value: "polkadot",
  chain: "polkadot",
  symbol: "DOT",
  decimals: 10,
  chainIcon: "originalPolkadot",
  color: "#057DCD",
  colorSecondary: "#43B0F1",
  buttonColor: "#E6007A",
  logo: "logo-img-2",
  modules: {
    ...treasuryModules,
    ...governanceModules,
  },
  treasuryWebsite: "https://www.dotreasury.com/dot",
  subSquareWebsite: "https://polkadot.subsquare.io",
};

export default polkadot;
